<xpo-ltl-shipment-detail
        *ngIf="config$ | async as config"
        [config]="config"
        [shipmentId]="shipmentId$ | async"
        [activeTab]="activeTab$ | async"></xpo-ltl-shipment-detail>